import _slicedToArray from "/Users/ashnakhetan/Desktop/ReactProjects/cv_plastics/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/Users/ashnakhetan/Desktop/ReactProjects/cv_plastics/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/ashnakhetan/Desktop/ReactProjects/cv_plastics/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var DEVICE_SIZES = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
export function useCol(_ref) {
  var as = _ref.as,
      bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["as", "bsPrefix", "className"]);

  bsPrefix = useBootstrapPrefix(bsPrefix, 'col');
  var spans = [];
  var classes = [];
  DEVICE_SIZES.forEach(function (brkPoint) {
    var propValue = props[brkPoint];
    delete props[brkPoint];
    var span;
    var offset;
    var order;

    if (typeof propValue === 'object' && propValue != null) {
      span = propValue.span;
      offset = propValue.offset;
      order = propValue.order;
    } else {
      span = propValue;
    }

    var infix = brkPoint !== 'xs' ? "-".concat(brkPoint) : '';
    if (span) spans.push(span === true ? "".concat(bsPrefix).concat(infix) : "".concat(bsPrefix).concat(infix, "-").concat(span));
    if (order != null) classes.push("order".concat(infix, "-").concat(order));
    if (offset != null) classes.push("offset".concat(infix, "-").concat(offset));
  });
  return [_objectSpread({}, props, {
    className: classNames.apply(void 0, [className].concat(spans, classes))
  }), {
    as: as,
    bsPrefix: bsPrefix,
    spans: spans
  }];
}
var Col = /*#__PURE__*/React.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (props, ref) {
  var _useCol = useCol(props),
      _useCol2 = _slicedToArray(_useCol, 2),
      _useCol2$ = _useCol2[0],
      className = _useCol2$.className,
      colProps = _objectWithoutProperties(_useCol2$, ["className"]),
      _useCol2$2 = _useCol2[1],
      _useCol2$2$as = _useCol2$2.as,
      Component = _useCol2$2$as === void 0 ? 'div' : _useCol2$2$as,
      bsPrefix = _useCol2$2.bsPrefix,
      spans = _useCol2$2.spans;

  return /*#__PURE__*/_jsx(Component, _objectSpread({}, colProps, {
    ref: ref,
    className: classNames(className, !spans.length && bsPrefix)
  }));
});
Col.displayName = 'Col';
export default Col;